<template>
    <div class="trinity-rings-spinner">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
    </div>
</template>

<script>
export default {
    name: "TrinityRings"
}
</script>

<style scoped lang="less">

@width: 60vh;
@height: 60vh;

.trinity-rings-spinner, .trinity-rings-spinner * {
    box-sizing: border-box;
}

.trinity-rings-spinner {
    height: @height;
    width: @width;
    padding: 3px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    overflow: hidden;
    box-sizing: border-box;
}
.trinity-rings-spinner .circle {
    position:absolute;
    display:block;
    border-radius:50%;
    border: 3px solid #ff1d5e;
    opacity: 1;
}

.trinity-rings-spinner .circle:nth-child(1) {
    height: @height;
    width: @width;
    animation : trinity-rings-spinner-circle1-animation 1.5s infinite linear;
    border-width: 3px;
}
.trinity-rings-spinner .circle:nth-child(2) {
    height: calc(@height * 0.65);
    width: calc(@width * 0.65);
    animation : trinity-rings-spinner-circle2-animation 1.5s infinite linear;
    border-width: 2px;
}
.trinity-rings-spinner .circle:nth-child(3) {
    height: calc(@height * 0.1);
    width: calc(@width * 0.1);
    animation:trinity-rings-spinner-circle3-animation 1.5s infinite linear;
    border-width: 1px;
}

@keyframes trinity-rings-spinner-circle1-animation{
    0% {
        transform: rotateZ(20deg) rotateY(0deg);
    }
    100% {
        transform: rotateZ(100deg) rotateY(360deg);
    }
}
@keyframes trinity-rings-spinner-circle2-animation{
    0% {
        transform: rotateZ(100deg) rotateX(0deg);
    }
    100% {
        transform: rotateZ(0deg) rotateX(360deg);
    }
}
@keyframes trinity-rings-spinner-circle3-animation{
    0% {
        transform: rotateZ(100deg) rotateX(-360deg);
    }
    100% {
        transform: rotateZ(-360deg) rotateX(360deg);
    }
}
</style>
